(function () {

  const ctnQty = Number(window.ctnQty);
  const ctnUnit = window.ctnUnit;

  if (!ctnQty || !ctnUnit) return;

  function initTable(table) {

    const headerRow = table.querySelector('thead tr');
    const rows = table.querySelectorAll('tbody tr');

    if (!headerRow || rows.length === 0) return;

    // 只做一次结构插入
    if (!table.dataset.ppuInit) {

      // header
      const th = document.createElement('th');
      th.className = 'ppu-header';
      th.textContent = `Price/${ctnUnit}`;
      headerRow.appendChild(th);

      // rows
      rows.forEach(row => {
        const td = document.createElement('td');
        td.className = 'ppu-cell';
        row.appendChild(td);
      });

      table.dataset.ppuInit = '1';
    }

    // 只更新数值（不动 DOM 结构）
    rows.forEach(row => {

      const priceCell = row.children[1];
      const targetCell = row.querySelector('.ppu-cell');

      if (!priceCell || !targetCell) return;

      const price = parseFloat(
        priceCell.textContent.replace(/[^0-9.]/g, '')
      );

      if (isNaN(price)) return;

      targetCell.textContent =
        '$' + (price / ctnQty).toFixed(2);
    });

    // 一次性显示（避免闪烁）
    requestAnimationFrame(() => {
      table.querySelectorAll('.ppu-header, .ppu-cell')
        .forEach(el => {
          el.style.visibility = 'visible';
        });
    });
  }

  function tick() {

    const table = document.querySelector(
      '.samitaWS_volumeTable_product_form table'
    );

    if (table) {
      initTable(table);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {

    setInterval(() => {
      tick();
    }, 200);

  });

})();